import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import { getPosts } from "../lib/api";

function fmt(d) {
  return new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
}

export default function News() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { getPosts().then(setPosts).catch(() => {}).finally(() => setLoading(false)); }, []);
  const [feature, ...rest] = posts;

  return (
    <div>
      <PageHeader label="News & Insights" titleLines={["The latest", "from NEAD."]}
        intro="Events, launches and stories from our communities: the projects, people and partnerships making a difference." />

      <section className="container-x py-24 md:py-32">
        {loading && <p className="text-nead-navy/50">Loading…</p>}

        {feature && (
          <Reveal>
            <Link to={`/news/${feature.slug}`} data-testid="news-feature" className="group grid lg:grid-cols-2 gap-10 items-center mb-16 rounded-[1.75rem] overflow-hidden bg-white border border-black/[0.07] shadow-sm hover:shadow-xl transition-all duration-500">
              <div className="overflow-hidden aspect-[16/12] lg:aspect-auto lg:h-full">
                <img src={feature.image} alt={feature.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-8 lg:p-10">
                <div className="flex items-center gap-3 text-xs font-semibold uppercase tracking-wider text-nead-cyan">
                  <span>{feature.category}</span><span>·</span><span>{fmt(feature.date)}</span>
                </div>
                <h2 className="mt-4 font-display font-bold text-3xl sm:text-4xl leading-tight tracking-tight text-nead-navy">{feature.title}</h2>
                <p className="mt-4 text-nead-navy/60 text-lg leading-relaxed">{feature.excerpt}</p>
                <span className="mt-6 inline-flex items-center gap-2 font-semibold text-nead-pink">
                  Read story <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </div>
            </Link>
          </Reveal>
        )}

        <Stagger className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {rest.map((p) => (
            <StaggerItem key={p.slug}>
              <Link to={`/news/${p.slug}`} data-testid={`news-card-${p.slug}`} className="group block rounded-[1.5rem] overflow-hidden bg-white border border-black/[0.07] shadow-sm hover:shadow-xl transition-all duration-500 hover:-translate-y-1.5 h-full">
                <div className="overflow-hidden aspect-[16/11]">
                  <img src={p.image} alt={p.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-nead-cyan">
                    <span>{p.category}</span><span>·</span><span>{fmt(p.date)}</span>
                  </div>
                  <h3 className="mt-3 font-display font-bold text-xl text-nead-navy group-hover:text-nead-pink transition-colors">{p.title}</h3>
                  <p className="mt-2 text-nead-navy/60 text-[0.95rem] line-clamp-2">{p.excerpt}</p>
                </div>
              </Link>
            </StaggerItem>
          ))}
        </Stagger>
      </section>
    </div>
  );
}
